import { Text, Tooltip, TooltipContent, TooltipTrigger } from '@/ui-kit'
import { clsx } from 'clsx'
import { PropsWithChildren, ReactNode } from 'react'

interface TextTooltipProps extends PropsWithChildren {
  text: ReactNode
  className?: string
  side?: 'top' | 'bottom' | 'left' | 'right'
}

export function TextTooltip({ text, className, children, side = 'bottom' }: TextTooltipProps): React.JSX.Element {
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger className="flex items-center gap-2">{children}</TooltipTrigger>
      <TooltipContent
        className={clsx('text-body-3 pointer-events-none rounded-xl bg-gray-100 px-3 py-2 select-none', className)}
        sideOffset={4}
        align="start"
        side={side}
      >
        <Text className="text-gray-80 mt-1" type="body3-regular">
          {text}
        </Text>
      </TooltipContent>
    </Tooltip>
  )
}
